/* eslint no-console:0 */
import "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"

import DispatchEventController from "../src/javascript/controllers/dispatch_event_controller"
import Select2Controller from "../src/javascript/controllers/select2_controller"
import TagInputController from "../src/javascript/controllers/tag_input_controller"
import ExpandableTextareaController from "../src/javascript/controllers/expandable_textarea_controller"
import ReadmoreController from "../src/javascript/controllers/readmore_controller"
import CssClassController from "../src/javascript/controllers/css_class_controller"

const application = Application.start()
application.register("dispatch-event", DispatchEventController)
application.register("select2", Select2Controller)
application.register("tag-input", TagInputController)
application.register("expandable-textarea", ExpandableTextareaController)
application.register("readmore", ReadmoreController)
application.register("css-class", CssClassController)

import 'jquery'
import 'bootstrap-sass'
import 'timeago'
import 'flatpickr'
import 'datatables.net'
import 'select2'

import 'url-search-params-polyfill';
import '../src/javascript/custom_event_polyfill'

import '../../../vendor/assets/javascripts/segment'
import '../../../vendor/assets/javascripts/jquery.tokenize'
import '../../../vendor/assets/javascripts/jquery.storageapi.min'

import '../../../vendor/assets/javascripts/angle/modules/bootstrap-start'
import '../../../vendor/assets/javascripts/angle/modules/calendar'
import '../../../vendor/assets/javascripts/angle/modules/clear-storage'
import '../../../vendor/assets/javascripts/angle/modules/constants'
import '../../../vendor/assets/javascripts/angle/modules/load-css'
import '../../../vendor/assets/javascripts/angle/modules/localize'
import '../../../vendor/assets/javascripts/angle/modules/panel-tools'
import '../../../vendor/assets/javascripts/angle/modules/utils'
import '../../../vendor/assets/javascripts/angle/modules/toggle-state'
import '../../../vendor/assets/javascripts/angle/app.init'

import '../../../vendor/assets/javascripts/readmore-vanilla.js'

import '../src/javascript/segment'

import '../src/javascript/bookmark_folders'
import '../src/javascript/bookmarks'
import '../src/javascript/facebook'
import '../src/javascript/media_assets'
import '../src/javascript/media_asset_action'
import '../src/javascript/media_uploads'
import '../src/javascript/inbox_items'
import '../src/javascript/social_profiles'
import '../src/javascript/tackboards'
import '../src/javascript/tags'
import '../src/javascript/users'
import '../src/javascript/orgs'
import '../src/javascript/reports'
import '../src/javascript/creators'